import React from 'react';

const MainButton = (props) => {

    const {title, icon, nw} = props

    return (
        <button
            style={{whiteSpace: nw ? 'nowrap' : 'normal'}}
            className={'main_button'}
        >
            {icon && icon}
            {title}
        </button>
    );
};

export default MainButton;